import { Collection } from '@share/interfaces';
import { ComeBackLater } from 'src/styles/emotion';
import { Link } from 'react-router-dom';
import { useAPI } from 'src/hooks';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { web3 } from '@state/web3';
import MiniCollectionCard from '@com/card/MiniCollectionCard';
import styled from '@emotion/styled';

const Section = styled.div`
  @media (max-width: 991px) {
    padding: 0 !important;
  }
`;

const CollectionList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  grid-gap: 2rem 3rem;
  min-height: min(25vh, 400px);

  @media (max-width: 500px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
`;

function PopularCollection(): JSX.Element {
  const { t } = useTranslation();
  const { chainId } = web3.useContainer();
  const { getPopularCollection } = useAPI();
  const { data } = useQuery(
    [getPopularCollection.name, chainId],
    () => getPopularCollection(chainId),
    { select: (_data) => _data?.slice(0, 3) }
  );

  return (
    <Section className="tf-section live-auctions style4 home5">
      <div className="themesflat-container mt-5">
        <div className="col-12">
          <div className="heading-live-auctions">
            <h2
              className="tf-title pb-39 text-left"
              data-test="top-collection-header"
            >
              {t('homePage.topCollection')}
            </h2>
            {data?.length > 0 && (
              <Link className="exp style2" to="/collection">
                {t('homePage.exploreMore')}
              </Link>
            )}
          </div>
        </div>
        {data?.length > 0 ? (
          <CollectionList className="px-5">
            {data?.map((item: Collection) => {
              return <MiniCollectionCard key={item.name} item={item} />;
            })}
          </CollectionList>
        ) : (
          <ComeBackLater>{t('collection.noData')}</ComeBackLater>
        )}
      </div>
    </Section>
  );
}

export default PopularCollection;
